(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["addons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const checkboxes = document.querySelectorAll('.product-addon-checkbox');

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        const productId = checkbox.getAttribute('data-product-id');

        if (checkbox.checked) {
          // Add the product to the cart
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: productId,
              quantity: 1
            })
          })
            .then((response) => response.json())
            .then((data) => {
              console.log('Product added to cart:', data);

              // Check cart type and redirect accordingly
              const cartType = Shopify.theme.settings.cart_type; // Assuming 'cart_type' is set in theme settings
              if (cartType === 'page') {
                // Redirect to cart page
                window.location.href = routes.cart_url;
              } else {
                // Open the cart drawer for other cart types
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  cartDrawer.classList.remove('is-empty');
                  fetch('/cart?view=drawer')
                    .then((response) => response.text())
                    .then((html) => {
                      const tempDiv = document.createElement('div');
                      tempDiv.innerHTML = html;
                      const newDrawerContent = tempDiv.querySelector('#CartDrawer');
                      document.querySelector('#CartDrawer').innerHTML = newDrawerContent.innerHTML;
                      cartDrawer.open();
                    });
                }
              }
            })
            .catch((error) => {
              console.error('Error adding product to cart:', error);
            });
        } else {
          // Handle product removal if unchecked
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: productId,
              quantity: 0
            })
          })
            .then((response) => response.json())
            .then((data) => {
              console.log('Product removed from cart:', data);
            })
            .catch((error) => {
              console.error('Error removing product from cart:', error);
            });
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
